import { apiSlice } from '../api/apiSlice'
import { ENDPOINTS } from '../../lib/endpoints'

export interface Category {
  id: string
  name: string
  slug: string
  color: string | null
  icon: string | null
  description: string | null
  isActive: boolean
  sortOrder: number
}

export const categoriesApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getCategories: builder.query<{ categories: Category[] }, void>({
      query: () => ENDPOINTS.discussions.categories,
      providesTags: ['Category'],
      keepUnusedDataFor: 60 * 60, // 1 hour — matches backend Redis TTL
    }),
  }),
})

export const { useGetCategoriesQuery } = categoriesApi
